/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { getTrafficFilterRulesetsUrl } from '@modules/cloud-api/v1/urls'

import asyncRequest from '../asyncRequests'
import { FETCH_TRAFFIC_FILTER_RULESETS } from '../../constants/actions'

export function fetchTrafficFilterRulesets({
  regionId,
  includeAssociations = true,
  organizationId,
}: {
  regionId?: string
  includeAssociations?: boolean
  organizationId?: string
}) {
  const url = getTrafficFilterRulesetsUrl({ includeAssociations, organizationId })

  return asyncRequest({
    type: FETCH_TRAFFIC_FILTER_RULESETS,
    method: `GET`,
    url,
    meta: { regionId },
    crumbs: [regionId ?? '__NO_REGION_ID__'],
  })
}
